export function replaceSpecialCharsInImageUrl(input: string) {
  return input.replaceAll(/[\s_]+/gu, '-').replaceAll(/[\s']+/gu, '_');
}
